/**
 * @generated SignedSource<<668ae9f57bd38d5e9cd5cd673f4abeaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionApprovalsFragment$data = {
  readonly anySubmission: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
  };
  readonly viewerCanApprove: boolean;
  readonly viewerCanReadPrivateApproval: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"FiltersForCompetitionApprovalsFragment" | "SubmissionsCompetitionApprovalsFragment">;
  readonly " $fragmentType": "CompetitionApprovalsFragment";
};
export type CompetitionApprovalsFragment$key = {
  readonly " $data"?: CompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionApprovalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "approvalFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionApprovalsFragment",
  "selections": [
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "alias": "viewerCanReadPrivateApproval",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "READ_COMPETITION_PRIVATE_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"READ_COMPETITION_PRIVATE_APPROVAL\")"
    },
    {
      "alias": "anySubmission",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "SubmissionConnection",
      "kind": "LinkedField",
      "name": "submissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubmissionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "submissions(first:1)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FiltersForCompetitionApprovalsFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "approvalFilter",
          "variableName": "approvalFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SubmissionsCompetitionApprovalsFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "f409bb0dc9e89cd4aca02b107565df3a";

export default node;
